import { Injectable } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class DomSanitizerService {
    // for edit and differ edit url
    public webEditorUrlSafe = null;
    public webDiffEditorUrlSafe = null;
    constructor(private sanitizer: DomSanitizer) {
      this.webEditorUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(environment.webEditorUrl);
      this.webDiffEditorUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(environment.webDiffEditorUrl);
    }

    public bypassSecurityTrustResourceUrl(url: string) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}  